import { forwardRef } from 'react';

import { cn } from 'src/utils/cn';
import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export type LogoProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href?: string;
  width?: number;
  height?: number;
  isSingle?: boolean;
  disableLink?: boolean;
};

export const Logo = forwardRef<HTMLAnchorElement, LogoProps>(
  (
    { width, href = '/', height, isSingle = true, disableLink = false, className, style, ...other },
    ref
  ) => {
    /*
    * OR using local (public folder)
    *
    const singleLogo = (
      <img
        alt="Single logo"
        src={`/logo/logo-single.svg`}
        width="100%"
        height="100%"
      />
    );

    const fullLogo = (
      <img
        alt="Full logo"
        src={`/logo/logo-full.svg`}
        width="100%"
        height="100%"
      />
    );
    *
    */

    const singleLogo = (
      <img
        src="/assets/newlogo/jjlogo.svg"
        alt="JobJourney Logo"
        className="w-full h-full object-contain"
      />
    );

    const fullLogo = (
      <img
        src="/assets/newlogo/jjlogo.svg"
        alt="JobJourney Logo"
        className="w-full h-full object-contain"
      />
    );

    const baseWidth = isSingle ? (width ?? 40) : (width ?? 102);
    const baseHeight = isSingle ? (height ?? 40) : (height ?? 36);

    return (
      <RouterLink
        ref={ref}
        href={href}
        className={cn(
          logoClasses.root,
          'inline-flex shrink-0 align-middle ml-2',
          disableLink && 'pointer-events-none',
          className
        )}
        aria-label="Logo"
        style={{
          width: baseWidth,
          height: baseHeight,
          ...style,
        }}
        {...other}
      >
        {isSingle ? singleLogo : fullLogo}
      </RouterLink>
    );
  }
);
